module.exports = __webpack_public_path__ + "static/media/salesforce.965376f0.webp";